import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "value",
      description: "SjTab属性值：绑定值，选中选项卡的name",
      type: "String",
      default: "第一个选项卡的 name"
    },
    {
      prop: "type",
      description: "SjTab属性值：风格类型",
      type: "String",
      available:
        "card/page/chrome，card为有最小宽度的标签，page则会横向撑满容器并均分,chrome类似chrome浏览器风格",
      default: "card"
    },
    {
      prop: "editable",
      description: "是否出现编辑按钮",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "size",
      description: "SjTab属性值：标签尺寸",
      type: "String",
      available: "middle/small",
      default: "small"
    },
    {
      prop: "before-leave",
      description:
        "SjTab属性值：切换标签之前的钩子，若返回 false 或者返回 Promise 且被 reject，则阻止切换。",
      type: "Function(activeName, oldActiveName)"
    },
    {
      prop: "label",
      description: "SjTabPane属性值：选项卡标题",
      type: "String",
      required: true
    },
    {
      prop: "name",
      description:
        "SjTabPane属性值：与选项卡 activeName 对应的标识符，表示选项卡别名",
      type: "String",
      default: "该选项卡在选项卡列表中的顺序值，如第一个选项卡则为'1'"
    },
    {
      prop: "lazy",
      description: "SjTabPane属性值：标签是否延迟渲染",
      type: "Boolean",
      default: false
    }
  ],
  events: [
    {
      name: "tab-click",
      description: "tab 被选中时触发"
    }
  ],
  propsChild: [
    {
      prop: "label",
      description: "选项卡标题",
      type: "String"
    },
    {
      prop: "name",
      description: "与选项卡 activeName 对应的标识符，表示选项卡别名",
      type: "String",
      default: "该选项卡在选项卡列表中的顺序值，如第一个选项卡则为'1'"
    },
    {
      prop: "lazy",
      description: "标签是否延迟渲染",
      type: "Boolean",
      default: false
    }
  ],
  slots: [
    {
      name: "label",
      description: "用于tabpane中，可自定义标签标题"
    },
    {
      name: "before",
      description: "用于非page形式的tab中，可在标签左侧传入自定义选项"
    },
    {
      name: "after",
      description: "用于非page形式的tab中，可在标签右侧传入自定义选项"
    }
  ]
};

export default DemoWrapper(Demo, DemoSource, config);
